var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMark = function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.031 3.47a.75.75 0 0 1 0 1.061l-6 6a.75.75 0 0 1-1.061 0l-3-3A.751.751 0 0 1 3.03 6.47l2.47 2.468 5.471-5.468a.75.75 0 0 1 1.062 0z"
  })));
};
export default SvgCheckMark;